<template>
  <div class="productionProcess" ref="productionProcess">
    <ul>
      <li v-for="(item, i) in processList" :key="i">
        <div class="li_title">{{ Object.keys(item)[0] }}</div>
        <ul class="li_context">
          <li
            v-for="(item_, i_) in Object.values(item)[0]"
            :key="i_"
            @click="checkProcessItem(item_)"
            :style="isOnLine(item_.runStatus)"
          >
            <div class="li_up">
              <img :src="getImgUrl(Object.keys(item)[0])" />
            </div>
            <div class="li_down">{{ item_.processName }}</div>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: ["matrix", "x", "y"],
  data() {
    //这里存放数据
    return {
      processList: [],
      currentId: null,
      intelligentMapObj: {},
    };
  },
  //计算属性 类似于data概念
  computed: {
    getImgUrl() {
      return (processName) => {
        try {
          return require(`./img/${processName}.png`);
        } catch (e) {
          return require(`./img/焦化.png`);
        }
      };
    },
    isOnLine() {
      return (runStatus) => {
        if (runStatus === 1) {
          return { opacity: 1 };
        } else {
          return { opacity: 0.4 };
        }
      };
    },
    markColor() {
      return (runStatus) => {
        if (runStatus == 1) {
          return "online";
        } else if (runStatus == 0) {
          return "outline";
        } else {
          return "noData";
        }
      };
    },
  },
  //监控data中的数据变化
  watch: {
    "$store.state.intelligentMapObj": {
      handler(newVal, oldVal) {
        this.intelligentMapObj = newVal;
      },
      deep: true,
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.intelligentMapObj = this.$store.state.intelligentMapObj;
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    let that = this;
    let w = $(that.$refs.productionProcess).outerWidth();
    let h = $(that.$refs.productionProcess).outerHeight();
    that.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y,
    });
    this.getData();
  },
  unmounted() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
    window.currentODlineArr =
      window.currentODlineArr && window.currentODlineArr.destroy();
  },
  //方法集合
  methods: {
    async getData() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      let firstlevelUrl = CONFIG.requestName + this.$apiOpt.firstlevel;
      // let firstlevelUrl =
      // "http://screen.bmetech.com/screen/homePage/productionProcess/firstlevel";
      let data = await this.$apiUtils.get(firstlevelUrl, {
        customerId: this.$store.state.customerId, //42
      });
      this.processList = [];
      if (data) {
        for (let i in data) {
          this.processList.push({ [i]: data[i] });
        }
        console.log("this.processList", this.processList);
      }
      this.timer = setTimeout(() => {
        this.getData();
      }, 60000);
    },
    closeAllColor() {
      let buildGroup = g_bme3dManager?.earth?.sceneTree?.$refs?.bgPower?.children;
      buildGroup &&
        buildGroup.forEach((item) => {
          item.enabled = false;
        });
    },
    createMask(id) {
      let info = this.intelligentMapObj[id];
      if (info && info.pos && info.pos.length > 0) {
        let json2 = {
          ref: `alert_${id}`,
          czmObject: {
            xbsjType: "Polygon",
            enabled: false,
            xbsjGuid: "a7a97abc-455e-4f3f-a54a-d6efb5c220a4",
            name: info.name,
            positions: info.pos,
            height: bmeConfig.productionProcessHeight
              ? bmeConfig.productionProcessHeight
              : 0,
            extrudedHeight: null,
            show: false,
            outline: {},
            ground: true,
          },
        };
        g_bme3dManager?.earth?.sceneTree?.$refs?.bgAlertPower?.children.push(json2);

        let json = {
          ref: id,
          czmObject: {
            xbsjType: "Polygon",
            enabled: false,
            xbsjGuid: "a7a97abc-455e-4f3f-a54a-d6efb5c220a4",
            name: info.name,
            positions: info.pos,
            height: bmeConfig.productionProcessHeight
              ? bmeConfig.productionProcessHeight
              : 0,
            extrudedHeight: null,
            show: false,
            outline: {},
            ground: true,
          },
        };
        let json3 = {
          ref: `poi_${id}`,
          czmObject: {
            xbsjType: "GeoPin",
            enabled: false,
            xbsjGuid: "d2e7f492-887a-45a7-af65-293a131d221a",
            name: info.name,
            evalString: "",
            position: [
              info.pos[0],
              info.pos[1],
              50 +
                (bmeConfig.productionProcessHeight
                  ? bmeConfig.productionProcessHeight
                  : 0),
            ],
            far: 1073741824,
            innerHTML: `<!DOCTYPE HTML>\n<html>\n\n<head>\n    <title></title>\n    <style>\n        .textContain {\n            position: absolute;\n            height: 38px;\n            background-color: rgba(0, 0, 0, 0.8);\n            box-shadow: 0px 8px 16px 0px rgba(74, 144, 226, 0.31);\n            \nborder-radius: 2px;\nborder: 1px solid #4A90E2;\n            padding: 5px 10px ;\n            line-height:28px;\n            white-space: nowrap;\n            top: -15px;\n            left: -50px;\n            font-size: 18px;\n            border:0;      \n            color: #F5A623;\n        }\n    </style>\n</head>\n<body>\n    <div class="textContain">${info.name}</div>\n</body>\n\n</html>`,
          },
        };
        g_bme3dManager?.earth?.sceneTree?.$refs?.bgPower?.children.push(json, json3);
        return g_bme3dManager.earth.sceneTree.$refs[id];
      } else {
        return null;
      }
    },
    changeColor(key1, key2) {
      this.closeAllColor();
      let currentBuild = g_bme3dManager.earth.sceneTree.$refs[key1.mapId];
      if (!currentBuild) {
        currentBuild = this.createMask(key1.mapId);
      }
      if (currentBuild) {
        currentBuild.enabled = true;
        currentBuild.czmObject.color = bmeConfig.bg_mark_color.markColor[key1.color];
        currentBuild.czmObject.outline.color =
          bmeConfig.bg_mark_color.markOutColor[key1.color];
        // currentBuild.czmObject.flyTo();
        this.openPoi(key1.mapId);
      }
      key2 &&
        key2.forEach((item) => {
          let retrogressiveItem = g_bme3dManager.earth.sceneTree.$refs[item.mapId];
          if (!retrogressiveItem) {
            retrogressiveItem = this.createMask(item.mapId);
          }
          if (retrogressiveItem) {
            this.openPoi(item.mapId);
            retrogressiveItem.enabled = true;
            retrogressiveItem.czmObject.color =
              bmeConfig.bg_mark_color.markColor[item.color];
            retrogressiveItem.czmObject.outline.color =
              bmeConfig.bg_mark_color.markOutColor[item.color];
          }
        });
    },
    async checkProcessItem(item) {
      if (item.id !== this.currentId) {
        let positionArr = [
          (item.longitude * 2 * Math.PI) / 360,
          (item.latitude * 2 * Math.PI) / 360,
          100,
        ];
        window.g_bme3dManager.earth.camera.flyTo(
          positionArr,
          2500,
          [0.783968080355887, -1.5044151748284547, 0.03280222548769185],
          2
        );
        this.currentId = item.id;
        let nextlevelUrl = CONFIG.requestName + this.$apiOpt.nextlevel;
        // let nextlevelUrl =
        //   "http://screen.bmetech.com/screen/homePage/productionProcess/nextlevel";
        let data = await this.$apiUtils.get(nextlevelUrl, {
          customerId: this.$store.state.customerId, //42
          id: item.id, //6
        });
        let currentBuilding = {
          mapId: item.mapId,
          color: this.markColor(item.runStatus),
        };
        let nextBuilding = [];
        let posObj = {
          current: {
            longitude: item.longitude,
            latitude: item.latitude,
          },
          next: [],
        };
        window.currentODlineArr =
          window.currentODlineArr && window.currentODlineArr.destroy();
        if (data) {
          console.log("===================");
          data.forEach((item_) => {
            posObj.next.push({
              longitude: item_.longitude,
              latitude: item_.latitude,
            });
            nextBuilding.push({
              mapId: item_.mapId,
              color: this.markColor(item_.runStatus),
            });
          });
          this.changeColor(currentBuilding, nextBuilding);
          window.currentODlineArr = this.createODLines(posObj);
        }
      } else {
        this.currentId = null;
        this.closeAllColor();
        window.currentODlineArr =
          window.currentODlineArr && window.currentODlineArr.destroy();
      }
    },
    openPoi(item) {
      let poiItem = g_bme3dManager?.earth?.sceneTree?.$refs[`poi_${item}`];
      if (poiItem) {
        poiItem.enabled = true;
      }
    },
    createODLines(ODlineData) {
      let odlineDealData = [];
      if (
        !ODlineData?.current?.longitude ||
        !ODlineData?.current?.latitude ||
        !ODlineData?.next?.length
      )
        return;
      ODlineData.next.forEach((item) => {
        if (!item.longitude || !item.latitude) {
          return true;
        }
        odlineDealData.push([
          [
            (ODlineData.current.longitude * Math.PI) / 180,
            (ODlineData.current.latitude * Math.PI) / 180,
            0,
          ],
          [(item.longitude * Math.PI) / 180, (item.latitude * Math.PI) / 180, 0],
        ]);
      });
      console.log("odlineDealData", odlineDealData);
      let earth = g_bme3dManager.earth;
      const odlines = new XE.Obj.ODLines(earth);
      odlines.color = [1, 1, 1, 1];

      var busLines = [];

      var p = odlineDealData;

      var positionsCollection = p.map((e) => {
        const toDegree = 180.0 / Math.PI;
        // Cesium.xbsjCreateTransmitPolyline 根据 首末端点生成弧线，
        // 参数有：
        // startPosition, 端点1
        // endPosition, 端点2
        // minDistance, 计算出的线段的最小间隔距离
        // heightRatio=1.0 弧线高度抬升程度，值越大，抬高得越明显
        // 返回值是cartesian类型的坐标数组
        const cartesians = Cesium.xbsjCreateTransmitPolyline(e[0], e[1], 50.0, 5.0);
        const poss = cartesians.map((ee) => {
          const carto = Cesium.Cartographic.fromCartesian(ee);
          return [carto.longitude, carto.latitude, carto.height];
        });

        return poss;
      });
      positionsCollection.push(...positionsCollection);
      /*positionsCollection.push(...positionsCollection);
      positionsCollection.push(...positionsCollection);*/

      let timeDuration = 10.0;
      let moveBaseDuration = 4.0;

      busLines = positionsCollection.map((e) => {
        return {
          positions: e,
          color: [0.5, 0.8, 1.0, 5.0],
          width: 5.0,
          startTime: timeDuration * Math.random(),
          duration: moveBaseDuration + 1.0 * Math.random(),
        };
      });

      odlines.data = busLines;
      odlines.timeDuration = timeDuration;
      odlines.playing = true;

      return odlines;
    },
  },
};
</script>
<style lang="scss" scoped>
.productionProcess {
  height: 790px;
  width: 600px;
  pointer-events: all;
  padding-top: 62px !important;
  & > ul {
    width: 100%;
    height: 100%;
    & > li {
      display: flex;
      &:not(:last-child) {
        margin-bottom: 10px;
      }
      .li_title {
        width: 91px;
        min-height: 79px;
        background: rgba(49, 53, 139, 0.5);
        border-radius: 2px;
        border: 1px solid #8badff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 500;
        color: #f5a623;
        font-size: 16px;
      }
      .li_context {
        width: calc(100% - 91px);
        display: flex;
        flex-wrap: wrap;
        & > li {
          width: 52px;
          cursor: pointer;
          .li_up {
            width: 52px;
            height: 54px;
            background: rgba(0, 0, 0, 0.5);
            border-radius: 2px;
            border: 1px solid #8badff;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .li_down {
            width: 52px;
            height: 25px;
            background: rgba(0, 0, 0, 0.5);
            border-radius: 2px;
            border: 1px solid #8badff;
            font-size: 13px;
            font-weight: 500;
            color: #e2effd;
            text-align: center;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            line-height: 25px;
          }
        }
      }
    }
  }
}
</style>
